import Handlebars from 'handlebars';
import AMApp from '../../global/app';

/**
 * BrochureCenter Module (Plain JS)
 */
export default class BrochureCenter {
  constructor(element, options = {}) {
    this.element = element;
    this.amApp = new AMApp();

    this.settings = {
      routeFondsBrochures: AMApp.langGetParam + 'eID=fonds&function=brochureCenter&isin=',
      ...options
    };

    const templateEl = document.getElementById('fonds_brochures_template');
    this.fondsBrochuresResultRaw = templateEl ? templateEl.innerHTML : '';
    this.fondsBrochuresResultTarget = document.getElementById('fonds_brochures_result_target');

    this.statusInit = this.element.querySelectorAll('.js_status_init');
    this.statusNoResult = this.element.querySelectorAll('.js_status_noresult');

    this.init();
  }

  init() {
    console.log('### BrochureCenter ###');
    // Event Delegation für Klicks auf ISIN-Elemente
    this.element.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-isin]');
      if (trigger) {
        event.preventDefault();
        const isin = trigger.dataset.isin;
        this.getFondsBrochures(isin);
      }
    });
  }

  /**
   * Get fonds brochures via Fetch API
   * @param {string} isin
   */
  async getFondsBrochures(isin) {
    // Loader vor das erste Status-Element einfügen
    if (this.statusInit.length > 0) {
      this.statusInit[0].insertAdjacentHTML('beforebegin', AMApp.LOADING_ANIMATION);
    }

    this.statusIsLoading();

    const url = AMApp.basePath + this.settings.routeFondsBrochures + encodeURIComponent(isin);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const result = await response.json();

      if (result) {
        this.renderFondsBrochures(result);
      }
    } catch (error) {
      console.error('error', error);
      this.statusError();
      this.removeLoader();
    }
  }

  /**
   * Render brochures using Handlebars
   * @param {Object} data
   */
  renderFondsBrochures(data) {
    if (data) {
      this.statusDataFound();
      if (this.fondsBrochuresResultRaw && this.fondsBrochuresResultTarget) {
        const compiledTemplate = Handlebars.compile(this.amApp.toHandlebarsDelimiters(this.fondsBrochuresResultRaw));
        this.fondsBrochuresResultTarget.innerHTML = compiledTemplate(data);
      }
    } else {
      this.statusNoData();
    }
  }

  /**
   * Status: Loading - handles visibility and smooth scrolling
   */
  statusIsLoading() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, true);

    if (window.innerWidth <= AMApp.CONSTANTS.BREAKPOINT.LG) {
      const loader = this.element.querySelector('.loader');
      if (loader) {
        window.scrollTo({
          top: loader.getBoundingClientRect().top + window.scrollY,
          behavior: 'smooth'
        });
      }
    }
  }

  statusNoData() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, false);
    this.removeLoader();
  }

  statusDataFound() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, true);
    this.removeLoader();
  }

  statusError() {
    this.toggleStatusElements(this.statusInit, true);
    this.toggleStatusElements(this.statusNoResult, false);
  }

  /**
   * Helper to toggle d-none class on NodeLists
   */
  toggleStatusElements(elements, shouldHide) {
    elements.forEach(el => {
      el.classList.toggle('d-none', shouldHide);
    });
  }

  removeLoader() {
    const loaders = this.element.querySelectorAll('.loader');
    loaders.forEach(loader => loader.remove());
  }
}